// extracted by mini-css-extract-plugin
export default {"rankedPageTabsContainer":"rankedPageTabsContainer-d3fPvY_i","storybookRankedPageTabsContainer":"storybookRankedPageTabsContainer-p4owunP8"};